import { defineMessages } from 'react-intl';

/** The head of the Insights page (design navigation-v2 b): one title over the three tabs. */
export const insightsMessages = defineMessages({
  title: { id: 'app.sml.insights.title', defaultMessage: 'Insights' },
  subtitle: {
    id: 'app.sml.insights.subtitle',
    defaultMessage: 'How your songs do on streaming, on social and with your fans.',
  },
});
